import React, { useRef } from "react";
import { CpdlcPidMenu, cpdlcPidView, useCenterCursor } from "@poscon/shared-frontend";
import { useRootDispatch, useRootSelector } from "~redux/hooks";
import type { Container as PixiContainer } from "pixi.js";
import { viewPositionSelector } from "~redux/slices/eramStateSlice";
import { useDragging } from "hooks/useDragging";
import { layerZIndexMap } from "~/layerZIndexMap";
import { useEventMode } from "components/utils/InteractiveContainer";
import { cpdlcSessionSelector } from "~redux/slices/aircraftSlice";
import { setAsel } from "~/redux/slices/eramTempStateSlice";
import { EramAircraftMenuProps } from "../menus/AircraftMenu";

const view = cpdlcPidView;

export const CpdlcPidMenuPrompt = ({ fp }: EramAircraftMenuProps) => {
  const fpId = fp.id;
  const dispatch = useRootDispatch();
  const ref = useRef<PixiContainer | null>(null);
  const pos = useRootSelector((state) => viewPositionSelector(state, view));
  const { startDrag } = useDragging(ref, view);
  const eventMode = useEventMode();
  const session = useRootSelector((state) => cpdlcSessionSelector(state, fpId));

  useCenterCursor(ref);

  return fp && session ? (
    <CpdlcPidMenu
      ref={ref}
      pos={pos}
      startDrag={startDrag}
      zIndex={layerZIndexMap.prompts}
      eventMode={eventMode}
      session={session}
      fp={fp}
      closeMenu={() => dispatch(setAsel(null))}
    />
  ) : null;
};
